var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C25.671 0 19.4841 1.87677 14.2218 5.39297C8.95939 8.90917 4.85787 13.9069 2.43587 19.7541C0.0138651 25.6014 -0.619841 32.0355 0.614885 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5497 62.1504 25.7571 63.3851C31.9645 64.6198 38.3986 63.9861 44.2459 61.5641C50.0931 59.1421 55.0908 55.0406 58.607 49.7782C62.1232 44.5159 64 38.329 64 32C64 23.5131 60.6286 15.3737 54.6274 9.37258C48.6263 3.37142 40.4869 0 32 0ZM52.9 21.26L26.62 47.52L11.1 32C10.5696 31.4696 10.2716 30.7501 10.2716 30C10.2716 29.2498 10.5696 28.5304 11.1 28C11.6304 27.4696 12.3499 27.1716 13.1 27.1716C13.8502 27.1716 14.5696 27.4696 15.1 28L26.66 39.56L48.94 17.3C49.4704 16.7696 50.1899 16.4716 50.94 16.4716C51.6901 16.4716 52.4096 16.7696 52.94 17.3C53.4704 17.8304 53.7684 18.5498 53.7684 19.3C53.7684 20.0501 53.4704 20.7696 52.94 21.3L52.9 21.26Z",
    fill: "#198754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cc4df0ec4c9af71c174de91d6870e316.svg";
export { ForwardRef as ReactComponent };